export interface CompanyPropertyType {
  listingId: string;
  name: string;
  state: string;
  street: string;
  city: string;
  listingIds?: Array<string>;
  contactEmail: string;
  active: boolean;
  unit: string;
}

export const CompanyProperty = ({
  listingId = '',
  name = '',
  street = '',
  state = '',
  city = '',
  listingIds = [],
  contactEmail = '',
  active = false,
  unit = '',
}: CompanyPropertyType) => ({
  listingId,
  name,
  street,
  state,
  city,
  listingIds,
  contactEmail,
  active,
  unit,
});
